export default {
  // Footer
  'navigation:common:footer:about-us': 'Über uns',
  'navigation:common:footer:faq': 'FAQ',
  'navigation:common:footer:brand-ambassador': 'Markenbotschafter*in werden',
  'navigation:common:footer:bonus-program': 'Bonusprogramm',
  'navigation:common:footer:jobs': 'Jobs / Karriere',

  // Trustbar
  'navigation:common:trustbar:consultation': 'Beratung',
  'navigation:common:trustbar:magazine': 'Magazin',
  'navigation:common:trustbar:faq': 'FAQ',
  'navigation:common:trustbar:bonus-program': 'Bonusprogramm',

  // Navigation Menu Items
  'navigation:menu:home': 'Home',
  'navigation:menu:dogs:home': 'Hunde',
  'navigation:menu:cats:home': 'Katzen',

  // Dogs Common Needs
  'navigation:dogs:needs:title': 'Nach Bedürfnis',
  'navigation:dogs:needs:picky-eaters': 'Wählerische Esser',
  'navigation:dogs:needs:digestive-problems': 'Verdauungsprobleme',
  'navigation:dogs:needs:skin-fur-problems': 'Haut- & Fellprobleme',
  'navigation:dogs:needs:intolerances': 'Unverträglichkeiten',
  'navigation:dogs:needs:overweight': 'Übergewicht',

  // Dogs Age Categories
  'navigation:dogs:age:title': 'Nach Alter',
  'navigation:dogs:age:puppy': 'Welpe (0-1 Jahre)',
  'navigation:dogs:age:adult': 'Adult (1-8 Jahre)',
  'navigation:dogs:age:senior': 'Senior (8+ Jahre)',

  // Dogs Breeds
  'navigation:dogs:breeds:title': 'Nach Rasse',
  'navigation:dogs:breeds:bulldog': 'Bulldogge',
  'navigation:dogs:breeds:chihuahua': 'Chihuahua',
  'navigation:dogs:breeds:dachshund': 'Dackel',
  'navigation:dogs:breeds:havanese-maltese': 'Havaneser & Malteser',
  'navigation:dogs:breeds:poodle': 'Pudel & Pudelmix',
  'navigation:dogs:breeds:retriever': 'Retriever',
  'navigation:dogs:breeds:shepherd': 'Schäferhund',
  'navigation:dogs:breeds:spitz': 'Spitz',
  'navigation:dogs:breeds:terrier': 'Terrier',
  'navigation:dogs:breeds:herding': 'Hütehund',

  // Dogs Food Types
  'navigation:dogs:food:wet': 'Nassfutter',
  'navigation:dogs:food:dry': 'Trockenfutter',

  // Dogs Product Types
  'navigation:dogs:products:sample-packs': 'Probierpakete',
  'navigation:dogs:products:wet-food': 'Nassfutter',
  'navigation:dogs:products:dry-food': 'Trockenfutter',
  'navigation:dogs:products:barf': 'BARF',
  'navigation:dogs:products:snacks': 'Snacks',

  // Dogs Snacks
  'navigation:dogs:snacks:title': 'Snacks',
  'navigation:dogs:snacks:all': 'Alle Snacks',
  'navigation:dogs:snacks:surprise-box': 'Überraschungsbox',
  'navigation:dogs:snacks:dental-care': 'Zahnpflege',
  'navigation:dogs:snacks:functional': 'Functional Snacks',
  'navigation:dogs:snacks:bones': 'Knochen & Kaurollen',
  'navigation:dogs:snacks:strips': 'Kaustreifen & Sticks',
  'navigation:dogs:snacks:training': 'Trainingssnacks',
  'navigation:dogs:snacks:pastes': 'Pasten & Cremesnacks',
  'navigation:dogs:snacks:toppers': 'Toppers',

  // Dogs Accessories and Health
  'navigation:dogs:accessories:title': 'Zubehör',
  'navigation:dogs:health:title': 'Pflege & Gesundheit',
  'navigation:dogs:health:general': 'Gesundheit',
  'navigation:dogs:products:accessories': 'Zubehör',
  'navigation:dogs:products:health': 'Gesundheit',

  // Dogs Additional Categories
  'navigation:dogs:categories:care': 'Pflege',
  'navigation:dogs:categories:supplements': 'Nahrungsergänzung',

  // Cats Navigation
  'navigation:cats:products:wet-food': 'Nassfutter',
  'navigation:cats:products:dry-food': 'Trockenfutter',
  'navigation:cats:products:snacks': 'Snacks',
  'navigation:cats:products:sample-packs': 'Probierpakete',
  'navigation:cats:products:accessories': 'Zubehör',
  'navigation:cats:products:health': 'Gesundheit',
  'navigation:cats:products:care': 'Pflege',
  'navigation:cats:products:supplements': 'Nahrungsergänzung',

  // Cats Needs
  'navigation:cats:needs:title': 'Spezielle Bedürfnisse',
  'navigation:cats:needs:picky-eaters': 'Sehr wählerisch',
  'navigation:cats:needs:digestive-problems': 'Verdauungsprobleme',
  'navigation:cats:needs:outdoor': 'Freigänger',
  'navigation:cats:needs:overweight': 'Übergewicht',
  'navigation:cats:needs:sterilized': 'Sterilisiert',

  // Cats Age
  'navigation:cats:age:title': 'Nach Alter',
  'navigation:cats:age:kitten': 'Kitten (0-1 Jahre)',
  'navigation:cats:age:adult': 'Adult (1-10 Jahre)',
  'navigation:cats:age:senior': 'Senior (10+ Jahre)',

  // Cats Snacks
  'navigation:cats:snacks:title': 'Snacks',
  'navigation:cats:snacks:all': 'Alle Snacks',
  'navigation:cats:snacks:surprise-box': 'Überraschungsbox',
  'navigation:cats:snacks:cream': 'Creme Snacks',
  'navigation:cats:snacks:soft': 'Soft Snacks',
  'navigation:cats:snacks:fillet': 'Filet Snacks',
  'navigation:cats:snacks:soups': 'Suppen',
  'navigation:cats:snacks:sensitive': 'Sensitiv',
  'navigation:cats:snacks:pastes': 'Pasten',

  // Common Service
  'navigation:common:service:title': 'Service',
  'navigation:common:service:dr-sam': 'Dr. Sam',
  'navigation:common:service:doguniversity': 'Doguniversity',
  'navigation:common:service:lassie': 'Lassie',

  // Footer - Useful Information
  'navigation:footer:useful:about-us': 'Über Uns',
  'navigation:footer:useful:healthy-pet-food': 'Was ist gesundes Tierfutter?',
  'navigation:footer:useful:premium-food': 'Warum Premium-Tiernahrung?',
  'navigation:footer:useful:food-transition': 'Umfütterung',
  'navigation:footer:useful:our-stores': 'Unsere Stores',

  // Footer - Good For You
  'navigation:footer:good:refer-friends': 'Freund*innen werben',
  'navigation:footer:good:become-ambassador': 'Markenbotschafter*in werden',
  'navigation:footer:good:savings-subscription': 'Unser Spar-Abo',

  // Footer - Help
  'navigation:footer:help:faq': 'Häufige Fragen',
  'navigation:footer:help:shipping': 'Versand',
  'navigation:footer:help:retail': 'Pets Deli im Handel',
  'navigation:footer:help:breeder-program': 'Züchter*innenprogramm',

  // Footer - Legal
  'navigation:footer:legal:jobs': 'Jobs',
  'navigation:footer:legal:imprint': 'Impressum',
  'navigation:footer:legal:privacy': 'Datenschutz',
  'navigation:footer:legal:terms': 'AGB und Widerruf',

  // Common
  'navigation:common:offers': 'Angebote',
};
